export const MRTDefaultTableOptions = {
    enableColumnOrdering: true,
    enableGlobalFilter: true,
    enableColumnDragging: true,
    enableColumnResizing: true,
    enableDensityToggle: false,
    enableFacetedValues: true,
    enableStickyFooter: true,
    muiTableContainerProps: { sx: { maxHeight: '63vh' } },
    positionToolbarAlertBanner: 'bottom' as 'bottom' | 'head-overlay' | 'top',
    defaultColumn: {
        minSize: 40, // equals default - 40
        maxSize: 10000, // by default was 1000
        size: 180, // equals default - 180
    },
    layoutMode: 'grid' as 'grid' | 'grid-no-grow' | 'semantic',
};
